<template>
    <div class=""></div>
</template>

<script>
export default {
    name:"Login",
    mounted(){
    var token = this.$route.query.token;
        if(token){
            localStorage.setItem('token',token);
            window.location.href = this.$url_path + "Highlight";
        }else {
            const getToken = localStorage.token;
            if(!getToken){
                window.location.href = "https://akun.kirei.co.id/login?myurl=" + this.$url_path;
            }else {
                window.location.href = this.$url_path + "Highlight";
            }
        }
    }

}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/Login.vue